import axios from 'axios';
import "../assets/styles/styles.scss";
//import "../commonComponents/nativeCarousel/styles/index.scss"
import "./styles/index.scss";
import config from '../config/environmentConfig';
import defaultConfig from '../config/defaults';
import { PostReview } from "./postReview/postReview";
import { reviewForm } from "../utils/reviewForm";
import { Utils } from "../utils/utils";
import { brandConfig } from "../brandConfig";
//import {NativeCarousel} from "../commonComponents/nativeCarousel/nativeCarousel"
import { doc } from "prettier";
import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';


export class inlineWidget {
    public allUploadedMedia;
    public imageUploadOpenFlag;
    public addPhotoListener;
    public backImageUploadState;
    public editImageUploadState;
    public editBeforeCancelOrUploadFlag;
    public fileObjectOnChangeAction;
    public editImageHandleEventListener;
    public updateImagehandleListener;
    public changeImageAndBackFlag;
    public onFocusEventHandleListener;
    constructor() {
        this.backImageUploadState = false;
        this.editImageUploadState = false;
        this.changeImageAndBackFlag = false;
    }

    initSwiper() {
        let self = this;
        const carousalTiles = 3;
        const myCustomSlider = document.querySelectorAll('.kr-inline-swiper .swiper');
        const myCustomPagination = document.querySelectorAll('.kr-inline-swiper .swiper-pagination');
        var swiper = [];

        for (let i = 0; i < myCustomSlider.length; i++) {
            if (!myCustomSlider[i].classList.contains('swiper-initialized')) {
                myCustomSlider[i].classList.add('swiper-container-' + i);
                myCustomPagination[i].classList.add('swiper-pagination-' + i);

                swiper[i] = new Swiper('.kr-inline-swiper .swiper-container-' + i, {
                    modules: [Navigation, Pagination, Scrollbar, A11y],
                    speed: 500,
                    slidesPerView: (carousalTiles + .25),
                    slidesPerGroup: carousalTiles,
                    spaceBetween: 10,
                    pagination: {
                        el: '.swiper-pagination-' + i,
                        type: 'bullets',
                        clickable: true,
                    },
                    navigation: {
                        nextEl: '.kr-inline-swiper .swiper-button-next',
                        prevEl: '.kr-inline-swiper .swiper-button-prev',
                    },
                });
                swiper[i].on('slideChange', function (e) {
                    let currentPage = e.snapIndex;
                    document.querySelector('.kr-inline-swiper .swiper-container-' + i + ' .swiper-wrapper').setAttribute('data-page', (currentPage + 1).toString());
                });
            }
        }
    }
    
    async getinlineForm(brand: string, locale: string, element: HTMLElement) {
        try {
            let self = this, loginApiRequest = {};
                loginApiRequest['brand'] = brand;
                loginApiRequest['locale'] = locale;
                loginApiRequest['v3_x_api_key'] = window.rrWidgetConfig.v3_x_api_key ? window.rrWidgetConfig.v3_x_api_key : '';;
                loginApiRequest['V3_API_URL'] = config.V3_API_URL;
                const loginUserData = await Utils.getLoginUserApiData(loginApiRequest);
                const inlineWidgetSelector = element;
                let carouselSelection = (inlineWidgetSelector.getAttribute('data-entity-carousel') && (inlineWidgetSelector.getAttribute('data-entity-carousel').toLowerCase() === 'true')) ? true : '';
                let dataAttributes = {};
                dataAttributes['entityList'] = inlineWidgetSelector.getAttribute('data-entity-list');
                dataAttributes['campaignId'] = inlineWidgetSelector.getAttribute('data-campaign-id');
                dataAttributes['entityCarousel'] = carouselSelection;
                axios({
                    method: 'get',
                    url: config.baseUrl + '/widget/inlineWidget',
                    params: {
                        brand,
                        locale,
                        entityType: dataAttributes['entityType'],
                        entityId: dataAttributes['entityList'],
                        entityCarousel: dataAttributes['entityCarousel'],
                        apikey: brandConfig.apikey,
                    },
                }).then(async (response) => {
                    var resultData = response.data;
                    if (element && resultData) {
                        element.innerHTML = resultData;
                    }
                    const parser = new DOMParser();
                    const htmlDoc = parser.parseFromString(response.data, 'text/html');
                    let postReviewObj = new PostReview();
                    postReviewObj.inlineUserFormHandler(element);
                    //let nativeCarouselObj = new NativeCarousel();
                    //nativeCarouselObj.init();
                    const rrWriteReviewEvent = new Event('rrWriteReview');
                    document.dispatchEvent(rrWriteReviewEvent);
                    self.brandOptinListener(locale, element);
                    postReviewObj.selectRating(element);
                    postReviewObj.sendUserPostRequest(brand, locale, dataAttributes, element);
                    postReviewObj.sendPostReviewRequest(brand, locale, dataAttributes, element);
                    if(window.ratingReview && window.ratingReview.events && window.ratingReview.events.rrWriteReview) {
                        window.ratingReview.events.rrWriteReview(inlineWidgetSelector);
                    }
                    self.initSwiper();
                    let reviewFormObj = new reviewForm();
                    let dropZone = element.querySelector('.drop-zone__input');
                    if (dropZone) {
                        reviewFormObj.addMediaUploadListener('.drop-zone__input', element);
                        reviewFormObj.tabListenerForBrowseImageButton(element);   
                    }
                    self.beforeunloadEvent(element);
                }).then(()=>{
                    if (loginUserData) {
                        self.updateUserLoginInformation(loginUserData, element);   
                    }
                }).catch((error) => {
                    console.error("error", error);
                });

        } catch (error) {
            console.error(error);
        }
        return;
    }

    beforeunloadEvent(element: any): void {
            window.addEventListener("beforeunload", function (e) {
                if (element.contains(document.activeElement)) {
                    var confirmationMessage = "Leaving this page will reset the wizard";
                    (e || window.event).returnValue = confirmationMessage; //Gecko + IE
                    return confirmationMessage;     
                }
            });   
        
    }

    brandOptinListener(locale: String, element: HTMLElement): void{
        let $brandOptin = (element.querySelector('.kr-brand-optin .kr-inline-checkbox') as HTMLInputElement),
            $unileverOptin = (element.querySelector('.kr-unilever-optin .kr-inline-checkbox') as HTMLInputElement);
        if($unileverOptin && locale==='en-gb'){
            $unileverOptin.addEventListener('change', ()=>{
                if ($unileverOptin.checked) {
                    let $formListItems = element.querySelectorAll('.kr-col .kr-show-if-brand'),
                        $rFname = (element.querySelector('.kr-inline-firstName') as HTMLInputElement),
                        $rLname = (element.querySelector('.kr-inline-lastName') as HTMLInputElement),
                        $profileData = localStorage.getItem('UnileverUserProfileData');
                    if($rFname && $profileData) {
                        $rFname.value = JSON.parse($profileData).profileAttrs.FirstName ? JSON.parse($profileData).profileAttrs.FirstName : '';
                        $rFname.disabled = true
                    }
                    if($rLname && $profileData) {
                        $rLname.value = JSON.parse($profileData).profileAttrs?.SurName ? JSON.parse($profileData).profileAttrs?.SurName : '';
                        $rLname.disabled = true
                    }
                    $formListItems.forEach((item)=>{
                        (item as HTMLElement).classList.remove('kr-hide');
                    })
                } else {
                    let $formListItems = element.querySelectorAll('.kr-col .kr-show-if-brand')
                    $formListItems.forEach((item)=>{
                        (item as HTMLElement).classList.add('kr-hide');
                    })
                }
            });
        } else if($brandOptin) {
            $brandOptin.addEventListener('change', ()=>{
                if ($brandOptin.checked) {
                    let $formListItems = element.querySelectorAll('.kr-col .kr-show-if-brand');
                    $formListItems.forEach((item)=>{
                        (item as HTMLElement).classList.remove('kr-hide');
                    })
                } else {
                    let $formListItems = element.querySelectorAll('.kr-col .kr-show-if-brand')
                    $formListItems.forEach((item)=>{
                        (item as HTMLElement).classList.add('kr-hide');
                    })
                }
            });
        }
    }

    observeinlineWidgetClass(summaryElements: HTMLElement[], brand: string, locale: string): void {
        let self = this;
        let handleListener = (ev) => {
            let $readPanelSelector = ev.detail && ev.detail.selectorElement? ev.detail.selectorElement : document.querySelector('[data-inline-template]');
            self.getinlineForm(brand, locale, ($readPanelSelector as HTMLElement));
        }
        let dispatchEvent = (element: HTMLElement) => {
            // prevent duplicate event dispatch for the same element
            //TODO: data-
            if (element.getAttribute('data-added')) return;
            if(element) {
                element.setAttribute('data-added', 'true');
                element.removeEventListener('writeReviewFormEvent', handleListener);
                element.addEventListener('writeReviewFormEvent', handleListener);
                let writeReviewFormEvent = new CustomEvent("writeReviewFormEvent", {
                    detail: {
                        selectorElement: element
                    }
                });
                element.dispatchEvent(writeReviewFormEvent);
            }
        };
        summaryElements.forEach((item: HTMLElement) => {
            if (Utils.isInViewport(item)) {
                dispatchEvent(item);
            } else {
                document.addEventListener('scroll', () =>{
                    if (Utils.isInViewport(item)) {
                        dispatchEvent(item);
                    }
                });
            }
        });
    }


    updateUserLoginInformation(loginUserData, element: HTMLElement):void {
        const self = this, $emailInput = element.querySelector('.kr-inline-email') as HTMLInputElement,
            $optinInput = element.querySelector('.kr-checkbox-optin') as HTMLInputElement,
            $firstNameInput = element.querySelector('.kr-inline-firstName') as HTMLInputElement,
            $lastNameInput = element.querySelector('.kr-inline-lastName') as HTMLInputElement;
        if ($emailInput && loginUserData['email']) {
            $emailInput.value = loginUserData['email'];
            $emailInput.disabled = true;
            if ($optinInput && loginUserData['profile']['optInStatus']) {
                if (loginUserData['profile']['optInStatus']['unileverEmailConsent'] || loginUserData['profile']['optInStatus']['brandEmailConsent'] || loginUserData['profile']['optInStatus']['unileverEmailOnlyConsent'] || loginUserData['profile']['optInStatus']['unileverOnlineOnlyConsent']) {
                    $optinInput.setAttribute('checked', 'true');
                    $firstNameInput.value = loginUserData['FirstName'];
                    $lastNameInput.value = loginUserData['SurName'];
                    element.querySelector('.kr-optin-fields').classList.add("kr-hide");
                } else {
                    $firstNameInput.value = loginUserData['FirstName'];
                    $lastNameInput.value = loginUserData['SurName'];
                }
                
            }
        }
    }
    

    updateReviewInputMessage($inputElem: HTMLInputElement, $reviewInputError: HTMLElement, radioFlag:boolean=false): void{
        let t= this;
        if ($inputElem && !radioFlag) {
            $inputElem.addEventListener('keyup', ()=>{
                t.getCountOfInputField($inputElem, $reviewInputError);
            });
        } else if($inputElem && radioFlag) {
            $inputElem.addEventListener('change', ()=>{
                t.getCountOfInputField($inputElem, $reviewInputError);
            });
        }
    }

    getCountOfInputField($inputElem: HTMLInputElement, $reviewInputError: HTMLElement): void{
        let reviewInputField = $inputElem.value;
        if ($reviewInputError && reviewInputField.length >0) {
            $reviewInputError.classList.add('kr-hide');
            $reviewInputError.classList.remove('show');
            $inputElem.classList.remove('error-focus');
        } else if($reviewInputError && reviewInputField){
            $reviewInputError.classList.add('kr-hide');
            $reviewInputError.classList.remove('show');
            $inputElem.classList.remove('error-focus');
        }
        return;
    }

    getCountMessage($reviewTxt: HTMLInputElement, element: HTMLElement): number{
        let $reviewCommentError = element.querySelectorAll('.kr-inline-comment-min-error span'),
            $reviewCommentMaxError = element.querySelectorAll('.kr-inline-comment-max-error span'),
            $reviewComment = element.querySelector('.kr-inline-reviewTxt');
        if ($reviewCommentError && ($reviewTxt.value).length >0) {
            $reviewCommentError[0].parentElement.classList.add('show');
            $reviewCommentError[0].parentElement.classList.remove('kr-hide');
            $reviewComment.classList.add('error-focus');
            $reviewCommentError[0].innerHTML = JSON.stringify(($reviewTxt.value).length);
            $reviewCommentError[0].classList.remove('kr-hide');
            $reviewCommentError[1].classList.remove('kr-hide');
            $reviewCommentMaxError[0].parentElement.classList.add('kr-hide');
            $reviewCommentMaxError[0].parentElement.classList.remove('show');
        }
        if ($reviewCommentError && (($reviewTxt.value).length < 1 || (($reviewTxt.value).length >= defaultConfig.fieldValidation.comment.min && ($reviewTxt.value).length <= defaultConfig.fieldValidation.comment.max))) {
            $reviewCommentError[0].parentElement.classList.add('kr-hide');
            $reviewCommentError[0].parentElement.classList.remove('show');
            $reviewCommentMaxError[0].parentElement.classList.add('kr-hide');
            $reviewCommentMaxError[0].parentElement.classList.remove('show');
            $reviewComment.classList.remove('error-focus');
            $reviewCommentError[0].classList.add('kr-hide');
            $reviewCommentError[1].classList.add('kr-hide');
            $reviewCommentMaxError[0].classList.add('kr-hide');
            $reviewCommentMaxError[1].classList.add('kr-hide');
        }
        if ($reviewCommentError && (($reviewTxt.value).length > defaultConfig.fieldValidation.comment.max)) {
            $reviewCommentMaxError[0].parentElement.classList.add('show');
            $reviewCommentMaxError[0].parentElement.classList.remove('kr-hide');
            $reviewComment.classList.add('error-focus');
            $reviewCommentMaxError[0].innerHTML = JSON.stringify(($reviewTxt.value).length);
            $reviewCommentMaxError[0].classList.remove('kr-hide');
            $reviewCommentMaxError[1].classList.remove('kr-hide');
            $reviewCommentError[0].parentElement.classList.add('kr-hide');
            $reviewCommentError[0].parentElement.classList.remove('show');
        }
        return ($reviewTxt.value).length;
    }











}